
export default "/assets/pause-micro.b3b3ce8f.svg"